import { render, staticRenderFns } from "./ArticleSelectionList.vue?vue&type=template&id=59ca29d0"
import script from "./ArticleSelectionList.vue?vue&type=script&lang=js"
export * from "./ArticleSelectionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports